import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                       */
const QuickFilterButton = ({
  className,
  active,
  label,
  ariaLabels,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  Button,
  {
    ...rest,
    className: classnames(
      "quick-filter-button",
      { "quick-filter-button--active": active },
      className
    ),
    variant: "outline",
    "aria-label": active ? ariaLabels?.active : ariaLabels?.inactive
  },
  /* @__PURE__ */ React.createElement("span", { className: "quick-filter-button__text" }, label),
  active && /* @__PURE__ */ React.createElement(Icon, { className: "quick-filter-button__icon", name: "close" })
);
export {
  QuickFilterButton,
  QuickFilterButton as default
};
//# sourceMappingURL=QuickFilterButton.js.map
